// Custom: Mini cart tab order fixes
// Custom: Move focus to subtotal after close button in mini cart
document.addEventListener('keydown', function(e) {
  // Only intercept the Tab key
  if (e.key !== 'Tab') return;

  const active = document.activeElement;
  const isShift = e.shiftKey;

  // 1. Identify the 'Close' button that was just focused after the update
  if (active && active.classList.contains('quantity_changed')) {
    
    // Forward Navigation: Tab (no Shift)
    if (!isShift) {
      const subtotal = document.querySelector('.mmc_title.mmc_footer_txt');
      if (subtotal) {
        e.preventDefault();
        // A small timeout ensures the browser doesn't overwrite your manual focus
        setTimeout(() => {
          subtotal.focus();
        }, 1000);
      }
    } 
    // Backward Navigation: Shift + Tab
    else {
      const currentRow = active.closest('.mmc_items');
      const plusBtn = currentRow ? currentRow.querySelector('.mmc_plus') : null;
      if (plusBtn) {
        e.preventDefault();
        plusBtn.focus();
      }
    }
  }
});



// ADA fixes for Dawn theme - by Out of the Sandbox
(function () {

  function fixThumbnailAccessibility() {

    // Fix empty overlay links
    document.querySelectorAll('.thumbnail-overlay__container > a:first-child').forEach(link => {
      if (!link.textContent.trim() && !link.querySelector('img')) {
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
      }
    });

    // Fix hidden product links
    document.querySelectorAll('.thumbnail-overlay__container .hidden-product-link').forEach(link => {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    });

  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", function () {
    fixThumbnailAccessibility();
  });

  // Observe DOM changes (Shopify loads products dynamically)
  const thumbnailObserver = new MutationObserver(() => {
    fixThumbnailAccessibility();
  });

  thumbnailObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


// Fix ARIA issues with Boost PFS filters by adding aria-labels to checkboxes that are missing them
function fixBrokenFilterARIA() {
  document.querySelectorAll('.boost-pfs-check-box[role="checkbox"]').forEach(box => {

    const labelledby = box.getAttribute('aria-labelledby');

    if (labelledby && !document.getElementById(labelledby)) {

      const labelText = box.closest('.boost-pfs-filter-button')
                           ?.querySelector('.boost-pfs-filter-option-value')
                           ?.textContent.trim();

      if (labelText) {
        box.removeAttribute('aria-labelledby');
        box.setAttribute('aria-label', labelText);
      }
    }
  });
}

// Run initially
document.addEventListener("DOMContentLoaded", fixBrokenFilterARIA);

// Watch for filter updates
const observer = new MutationObserver(fixBrokenFilterARIA);

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Add tabindex to announcement bar text for accessibility
document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector('.announcement-bar__text');

  if (bar) {
    const firstP = bar.querySelector('p:first-of-type');

    if (firstP) {
      firstP.setAttribute('tabindex', '0');
    }
  }
});

// Add tabindex to mega menu content for accessibility
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.mega-menu__content.content p').forEach(p => {
    p.setAttribute('tabindex', '0');
  });
});

// Hide secondary images in product thumbnails from screen readers and keyboard navigation to prevent confusion, as they are decorative and not meant to be focused on or read by assistive technologies.
(function () {

  function hideSecondaryImages() {

    const secondaryImages = document.querySelectorAll(
      '.product__imageContainer img.secondary, img.secondary'
    );

    secondaryImages.forEach(img => {

      // Hide from screen readers
      img.setAttribute('aria-hidden', 'true');

      // Decorative image → empty alt
      img.setAttribute('alt', '');

      // Prevent accidental focus (rare but safe)
      img.setAttribute('tabindex', '-1');

    });

  }

  // Run on load
  window.addEventListener('load', hideSecondaryImages);

  // Run after AJAX / Boost / infinite scroll / filters
  const observer = new MutationObserver(hideSecondaryImages);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Fix ARIA labels on color swatches that are missing them, which can happen when using certain metafield naming conventions that include "meta" and "print", by cleaning up the swatch name and applying it as an aria-label for better accessibility.
(function () {

  function fixSwatchLabels() {

    const swatches = document.querySelectorAll('a.swatch');

    swatches.forEach(swatch => {

      const swatchName = swatch.getAttribute('data-swatch-name');
      if (!swatchName) return;

      // Clean value (meta-print_crimson_floral → Crimson Floral)
      const cleanName = swatchName
        .replace(/meta[-_]?print[-_]?/i, '')
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase())
        .trim();

      // Replace bad aria-label
      swatch.setAttribute('aria-label', `select ${cleanName}`);

    });

  }

  // Run after load
  window.addEventListener('load', fixSwatchLabels);

  // Re-run after Boost / AJAX / filtering
  const observer = new MutationObserver(fixSwatchLabels);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Focus on error messages when they appear on the login form to ensure they are announced by screen readers and easily noticed by keyboard users, improving accessibility for users who encounter login issues.
window.addEventListener('load', function () {

  const errorBox = document.querySelector('.errors ul li');

  if (errorBox) {

    errorBox.setAttribute('tabindex', '-1');
    errorBox.focus();

  }

});

// Hide empty "Open this option" links in thumbnail overlays that can appear when there are no variant options, which can cause confusion for screen reader and keyboard users, by adding aria-hidden and tabindex attributes to hide them from assistive technologies and prevent them from being focusable.
document.querySelectorAll('.thumbnail-overlay__container > a[aria-label="Open this option"]')
  .forEach(function(link) {
    link.setAttribute('aria-hidden', 'true');
    link.setAttribute('tabindex', '-1');
  });

// Add tabindex to product description paragraphs for better accessibility, allowing keyboard users to navigate through the product description text and have it announced by screen readers, improving the overall user experience for those relying on assistive technologies.
  window.addEventListener('load', function () {
  const paragraphs = document.querySelectorAll('.image-with-text__text p');

  paragraphs.forEach(function(paragraph) {
    paragraph.setAttribute('tabindex', '0');
  });
});

// Split the taxes and shipping message in the mini cart into separate focusable elements to ensure that screen readers can properly announce the information and keyboard users can navigate through it effectively, improving accessibility for users reviewing their cart details.
document.addEventListener('DOMContentLoaded', function () {

  const paragraph = document.querySelector('.mmc_footer_txt.cart__taxes-shipping-message');
  if (!paragraph) return;

  const link = paragraph.querySelector('a');
  if (!link) return;

  const nodes = Array.from(paragraph.childNodes);

  let beforeText = '';
  let afterText = '';
  let foundLink = false;

  nodes.forEach(node => {
    if (node === link) {
      foundLink = true;
    } else if (!foundLink && node.nodeType === 3) {
      beforeText += node.textContent;
    } else if (foundLink && node.nodeType === 3) {
      afterText += node.textContent;
    }
  });

  paragraph.innerHTML = '';

  // BEFORE SPAN
  if (beforeText) {
    const beforeSpan = document.createElement('span');
    beforeSpan.textContent = beforeText;
    beforeSpan.setAttribute('tabindex', '0');
    paragraph.appendChild(beforeSpan);
  }

  // Add space before link if needed
  paragraph.appendChild(document.createTextNode(' '));

  // LINK
  paragraph.appendChild(link);

  // Add space after link
  paragraph.appendChild(document.createTextNode(' '));

  // AFTER SPAN
  if (afterText) {
    const afterSpan = document.createElement('span');
    afterSpan.textContent = afterText.trim();
    afterSpan.setAttribute('tabindex', '0');
    paragraph.appendChild(afterSpan);
  }

});

// Trap focus within the mini cart when it's open to prevent keyboard users from accidentally tabbing out of the cart and into the underlying page content, improving accessibility and user experience for those navigating with a keyboard.
(function () {

  function trapMiniCartFocus() {

    const miniCart = document.querySelector('.min_cart, .mmc_drawer, .cart-drawer'); // adjust if needed
    if (!miniCart) return;

    const focusableSelectors = `
      a[href],
      button:not([disabled]),
      textarea,
      input,
      select,
      [tabindex]:not([tabindex="-1"])
    `;

    const focusableElements = miniCart.querySelectorAll(focusableSelectors);

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    miniCart.addEventListener('keydown', function (e) {

      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        // SHIFT + TAB
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        // TAB
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }

    });

  }

  document.addEventListener('DOMContentLoaded', trapMiniCartFocus);

})();

// Add ARIA labels to Fancybox navigation buttons for better accessibility, ensuring that screen readers can announce the purpose of the previous and next buttons in the image gallery, improving the user experience for those relying on assistive technologies.
document.addEventListener('click', function () {

  setTimeout(function () {

    const prevBtn = document.querySelector('[data-fancybox-prev]');
    const nextBtn = document.querySelector('[data-fancybox-next]');

    if (prevBtn) {
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.removeAttribute('title');
    }

    if (nextBtn) {
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.removeAttribute('title');
    }

    // Hide SVG from screen readers
    document.querySelectorAll('.fancybox-button svg')
      .forEach(svg => svg.setAttribute('aria-hidden', 'true'));

  }, 300); // delay so Fancybox fully renders

});

// Add ARIA labels to Fancybox control buttons for better accessibility, ensuring that screen readers can announce the purpose of the zoom, play, thumbnails, and close buttons in the image gallery, improving the user experience for those relying on assistive technologies.
document.addEventListener('click', function () {

  setTimeout(function () {

    const zoomBtn   = document.querySelector('[data-fancybox-zoom]');
    const playBtn   = document.querySelector('[data-fancybox-play]');
    const thumbsBtn = document.querySelector('[data-fancybox-thumbs]');
    const closeBtn  = document.querySelector('[data-fancybox-close]');

    if (zoomBtn) {
      zoomBtn.setAttribute('aria-label', 'Zoom image');
      zoomBtn.removeAttribute('title');
    }

    if (playBtn) {
      playBtn.setAttribute('aria-label', 'Start slideshow');
      playBtn.removeAttribute('title');
    }

    if (thumbsBtn) {
      thumbsBtn.setAttribute('aria-label', 'Show thumbnails');
      thumbsBtn.removeAttribute('title');
    }

    if (closeBtn) {
      closeBtn.setAttribute('aria-label', 'Close gallery');
      closeBtn.removeAttribute('title');
    }

    // Hide all SVG icons from screen readers
    document.querySelectorAll('.fancybox-button svg')
      .forEach(svg => svg.setAttribute('aria-hidden', 'true'));

  }, 300);

});

// Add tabindex to product description paragraphs for better accessibility, allowing keyboard users to navigate through the product description text and have it announced by screen readers, improving the overall user experience for those relying on assistive technologies.
$(document).ready(function() {
    var $container = $('.pdacd_description');

    // 1. Add tabindex to the list items and paragraphs
    $container.find('li, p').attr('tabindex', '0');
    $container.find('ul li').attr('tabindex', '0');
    $container.find('p span').attr('tabindex', '0');

    // 2. Remove tabindex from the parent container to prevent "double tabbing"
    // This ensures the focus goes directly to the first line of text.
    if ($container.find('li, p').length > 0) {
        $container.removeAttr('tabindex');
    }

    // 3. Optional: Fix for empty <p> tags (like the one at the top of your HTML)
    $container.find('p').each(function() {
        if ($(this).text().trim() === "") {
            $(this).removeAttr('tabindex'); // Don't focus empty lines
        }
    });
});

// Force hide zoom images added by the library with aria-hidden and other attributes to ensure they are not announced by screen readers or focusable, as they are decorative and can cause confusion for users relying on assistive technologies.

  (function() {
    const forceHideZoom = (img) => {
      if (img.getAttribute('aria-hidden') !== 'true') {
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('alt', ''); // Ensure alt is empty
        img.setAttribute('tabindex', '-1'); // Remove from tab order
        img.setAttribute('role', 'presentation'); // Extra reinforcement
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // 1. Catch newly added images
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList.contains('zoomImg')) forceHideZoom(node);
            node.querySelectorAll('.zoomImg').forEach(forceHideZoom);
          }
        });
        // 2. Catch if the library tries to remove the attribute on an existing image
        if (mutation.type === 'attributes' && mutation.target.classList.contains('zoomImg')) {
          forceHideZoom(mutation.target);
        }
      });
    });

    // Start watching the body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'alt', 'src', 'class']
    });

    // Initial run for images already on page
    document.querySelectorAll('.zoomImg').forEach(forceHideZoom);
  })();

// Function to hide secondary images for accessibility by adding aria-hidden, role, alt, and tabindex attributes
  function hideSecondaryImages(){
  document.querySelectorAll('.slider-gallery img.secondary, .product__imageContainer img.secondary').forEach(function(img){

    img.setAttribute('aria-hidden','true');
    img.setAttribute('role','presentation');
    img.setAttribute('alt','');
    img.setAttribute('tabindex','-1');

    var wrapper = img.closest('.image-element__wrap');
    if(wrapper){
      wrapper.setAttribute('aria-hidden','true');
    }

  });
}

document.addEventListener("DOMContentLoaded", hideSecondaryImages);
window.addEventListener("load", hideSecondaryImages);

// Function to add accessibility attributes to the current image in the Fancybox gallery, ensuring that it is focusable and announced as an image by screen readers, improving the user experience for those relying on assistive technologies.
function updateFancyboxImageAccessibility() {

  const currentImg = document.querySelector('.fancybox-slide--current img.fancybox-image');

  if (currentImg && !currentImg.hasAttribute('tabindex')) {
    currentImg.setAttribute('tabindex', '0');
    currentImg.setAttribute('role', 'img');
  }

}

// run repeatedly while fancybox is open
setInterval(function () {

  if (document.querySelector('.fancybox-container')) {
    updateFancyboxImageAccessibility();
  }

}, 300);

// Function to add accessibility attributes to the product description in the Fancybox quick shop, allowing keyboard users to navigate through the description text and have it announced by screen readers, improving the overall user experience for those relying on assistive technologies.
function applyDescriptionAccessibility() {

    var $container = $('.fancybox-container .pdacd_description');

    if ($container.length) {

        // add tabindex to paragraphs and list items
        $container.find('li, p').attr('tabindex','0');
        $container.find('ul li').attr('tabindex','0');

        // remove tabindex from container
        if ($container.find('li, p').length > 0) {
            $container.removeAttr('tabindex');
        }

        // remove tabindex from empty paragraphs
        $container.find('p').each(function(){
            if ($(this).text().trim() === "") {
                $(this).removeAttr('tabindex');
            }
        });

    }
}

document.addEventListener('click', function () {

    setTimeout(function () {
        applyDescriptionAccessibility();
    }, 500); // wait for quick shop content to render

});

// Function to make swatch titles accessible in the Fancybox quick shop by adding tabindex, role, aria-live, and aria-label attributes, ensuring that screen readers can announce the swatch options and keyboard users can navigate to them effectively, improving accessibility for users selecting product variants.
function makeSwatchReadable() {
  const swatchTitle = document.querySelector('.fancybox-content .options-selection__option-name');

  if (swatchTitle) {
    swatchTitle.setAttribute('tabindex', '0'); // make focusable
    swatchTitle.setAttribute('role', 'heading');
    swatchTitle.setAttribute('aria-live', 'polite');
    swatchTitle.setAttribute('aria-label', swatchTitle.innerText);
  }
}

// Only make the swatch readable when the details section is focused
document.addEventListener('focusin', function (e) {
  if (e.target.matches('.product__view-details')) {
    setTimeout(makeSwatchReadable, 300); // do not focus automatically
  }
});

// Function to fix keyboard navigation from Shop Pay wallet button to "More payment options" link by adding a keydown listener that intercepts the Tab key and manually moves focus to the next logical element, improving accessibility for keyboard users navigating the checkout options.
document.addEventListener('focusin', (e) => {
  const walletButton = document.querySelector('shop-pay-wallet-button');
  const moreOptions = document.querySelector('#more-payment-options-link');

  if (walletButton && moreOptions) {
    // Make sure the wallet button itself is tabbable
    if (!walletButton.hasAttribute('tabindex')) walletButton.setAttribute('tabindex', '0');

    // Intercept Tab when wallet button is focused
    walletButton.addEventListener('keydown', function (evt) {
      if (evt.key === 'Tab' && !evt.shiftKey) {
        evt.preventDefault(); // stop default "trapped focus"
        moreOptions.focus(); // manually move to next button
      }
    });
  }
});

// Function to update ARIA labels on the small close button in the Fancybox quick shop for better accessibility, ensuring that screen readers can announce the purpose of the close button accurately, improving the user experience for those relying on assistive technologies.
  (function() {
    const updateFancyboxAccessibility = () => {
      // Target the small close button specifically
      const closeBtns = document.querySelectorAll('.fancybox-close-small, [data-fancybox-close]');
      
      closeBtns.forEach(btn => {
        // Only set it if it hasn't been set yet to avoid constant re-runs
        if (btn.getAttribute('aria-label') !== 'Close Quick Shop') {
          btn.setAttribute('aria-label', 'Close Quick Shop');
          // Ensure the SVG inside is hidden so it doesn't try to read paths
          const svg = btn.querySelector('svg');
          if (svg) svg.setAttribute('aria-hidden', 'true');
          
        }
      });
    };

    // Watch the body for the Fancybox popup being added to the DOM
    const observer = new MutationObserver((mutations) => {
      updateFancyboxAccessibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Run once in case it's already open
    updateFancyboxAccessibility();
  })();

// Function to remove tabindex from logo images in the header to prevent them from being focusable, as they are decorative and not meant to be interactive elements, improving accessibility for users navigating with a keyboard or assistive technologies.
  function removeLogoTabindex() {
  var logoImages = document.querySelectorAll('.header__logo img');

  logoImages.forEach(function(img) {
    img.removeAttribute('tabindex');
  });
}

// Run after page loads
document.addEventListener('DOMContentLoaded', function () {
  removeLogoTabindex();
});

// Function to fix ARIA issues with variant option names in the Fancybox quick shop by restructuring the HTML to separate the option name and value into distinct elements with appropriate ARIA attributes, improving accessibility for screen readers and keyboard users when selecting product variants.
(function () {

  function fixVariantOptionAccessibility() {

    document.querySelectorAll('.options-selection__option-name').forEach(function(container){

      // Remove tabindex from parent
      container.removeAttribute('tabindex');

      // Prevent duplicate processing
      if(container.querySelector('.ada-option-label')) return;

      const textNode = container.childNodes[0];

      if(textNode && textNode.nodeType === 3 && textNode.textContent.trim() !== '') {

        const labelSpan = document.createElement('span');
        labelSpan.className = 'ada-option-label';
        labelSpan.setAttribute('tabindex','0');
        labelSpan.textContent = textNode.textContent.trim();

        // Insert label span
        container.insertBefore(labelSpan, textNode);

        // Add space after first span
        const space = document.createTextNode(' ');
        container.insertBefore(space, textNode);

        // Remove original text node
        container.removeChild(textNode);
      }

      // Add tabindex to value span
      const valueSpan = container.querySelector('span:not(.ada-option-label)');
      if(valueSpan){
        valueSpan.setAttribute('tabindex','0');
      }

    });

  }

  document.addEventListener("DOMContentLoaded", function(){
    fixVariantOptionAccessibility();
  });

  const variantObserver = new MutationObserver(function(){
    fixVariantOptionAccessibility();
  });

  variantObserver.observe(document.body,{
    childList:true,
    subtree:true
  });

})();


// Function to fix keyboard navigation in the installment tab of the Fancybox quick shop by adding a keydown listener that intercepts the Tab key and manually moves focus between the "Learn more" button, the description, and the price, creating a logical focus loop for better accessibility.
(function () {

  function fixInstallmentTabbing() {

    const learnMoreBtn = document.querySelector('#quickshop shopify-payment-terms');
    const nextElement = document.querySelector('#quickshop .description_top p');
    const prevElement = document.querySelector('#quickshop .modal_price .money');

    if (!learnMoreBtn || !nextElement || !prevElement) return;

    learnMoreBtn.addEventListener('keydown', function (e) {

      // TAB → go to description
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        nextElement.focus();
      }

      // SHIFT + TAB → go to price
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        prevElement.focus();
      }

    });

  }

  // Detect Quick Shop / Fancybox opening
  document.addEventListener('click', function () {

    setTimeout(function () {
      fixInstallmentTabbing();
    }, 600); // wait for popup content to render

  });

})();

// Function to fix accessibility issues with the footer logo by adding tabindex attributes to hide it from screen readers and prevent it from being focusable, as it is decorative and not meant to be an interactive element, improving accessibility for users navigating with a keyboard or assistive technologies.
(function () {

  function fixFooterLogoAccessibility() {

    const footerImages = document.querySelectorAll('.footer__logo-wrapper img');

    footerImages.forEach(function(img) {
      img.setAttribute('tabindex', '-1');
    });

  }

  document.addEventListener('DOMContentLoaded', fixFooterLogoAccessibility);

})();



